import { useState,useMemo  } from 'react';
import { useLocation } from 'react-router-dom';

import { Tabs, TabsList, TabsTrigger, TabsContent } from 'components/ui/tabs';
import WashingInstructions from './WashingInstructions';
import WarningInstructions from './WarningInstructions';
import PriceInstructions from './PriceInstructions';
import BeltInstructions from './BeltInstructions';
import BrandInstructions from './BrandInstructions';
import CordInstructions from './CordInstructions';
import AddionalInstructions from './AddionalInstructions';
import useTemNewStore from 'store/client/temNewStore'
import EmptyInstructions from './EmptyInstructions';
import Label11Instructions from './HomeLabel11Instructions';
import Label12Instructions from './HomeLabel12Instructions';
import ExtraHomeCardInstructions from './ExtraHomeCardInstructions';

function parsePart(s = '') {
  // "6829..._ZaraHome" -> { id: "6829...", name: "ZaraHome" }
  const [first, ...rest] = s.split('_');
  const last = rest.length ? rest[rest.length - 1] : '';
  return { id: first || '', name: decodeURIComponent(last || '') };
}
export default function BottomSection({ brand, dept, subDept }) {
  const [currentTab, setCurrentTab] = useState("0");
  const settabvalue = useTemNewStore((state) => state.settabvalue);
  const handleTabChange = (newValue) => {
    setCurrentTab(newValue);
    settabvalue(newValue);
  };
  const { pathname } = useLocation();
  const urlData = useMemo(() => {
    // path'i normalize et: query/hash çıkar, boşları at
    const parts = pathname.split('?')[0].split('#')[0].split('/').filter(Boolean);
    // .../siparisler/ekle/:brandPart/:subDeptPart/:agePart(/:draftId?)
    const ekleIndex = parts.findIndex((p) => p === 'ekle');
    const brandPart = parts[ekleIndex + 1] || '';
    const subDeptPart = parts[ekleIndex + 2] || '';
    const agePart = parts[ekleIndex + 3] || ''; // "ADULT" gibi

    const brand = parsePart(brandPart);     // { id, name }
    const dept  = parsePart(subDeptPart);   // { id, name }
    const age   = decodeURIComponent(agePart);

    return {
      brandId: brand.id,
      brandName: brand.name,
      deptId: dept.id,
      deptName: dept.name,
      age,
    };
  }, [pathname]);



  const { brandName, deptName,age } = urlData;



  return (
    <Tabs defaultValue="0" onValueChange={handleTabChange}>
      <div className="flex justify-center">
        <TabsList>
          <TabsTrigger value="0">Yıkama Talimatı</TabsTrigger>
          <TabsTrigger value="1">
  {brand !== "ZaraHome" ? "Uyarı Talimatı" : "Triman"}
</TabsTrigger>
          <TabsTrigger value="2">
  {brand !== "ZaraHome" ? "Fiyat Etiketi" : "Label 9"}
</TabsTrigger>
    {deptName === "Bedlinen" && (
            <>
              <TabsTrigger value="8">Label 11</TabsTrigger>
           
              <TabsTrigger value="9">Label12</TabsTrigger>
            </>
          )}
   <TabsTrigger value="4">Marka Etiketi</TabsTrigger>

   <TabsTrigger value="3">{brand !== "ZaraHome" ? "Kemer Kartı" : "Sallantı"}</TabsTrigger>

          {brand !== "ZaraHome" && (
            <>
              <TabsTrigger value="7">Bos Dugme Kartı</TabsTrigger>
           
              <TabsTrigger value="5">İp</TabsTrigger>
              <TabsTrigger value="6">Ek Sallantı Kartı</TabsTrigger>
            </>
          )}

          {brand === "ZaraHome" && (
            <TabsTrigger value="10">Ekstra Kart</TabsTrigger>
          )}
        
        </TabsList>
      </div>

      <TabsContent value="0">
        <div className="rounded bg-white p-5 shadow-xl">
          <WashingInstructions brannd={brand}  />
        </div>
      </TabsContent>
      <TabsContent value="1">
            <div className="rounded bg-white p-5 shadow-xl">
              <WarningInstructions brannd={brand} />
            </div>
          </TabsContent>
      <TabsContent value="2">
            <div className="rounded bg-white p-5 shadow-xl">

             <PriceInstructions brannd={brand} deptName={deptName} subDept={age} />
       
            </div>


          </TabsContent>
          {deptName === "Bedlinen" && (
            <>
            <TabsContent value="8">
            <div className="rounded bg-white p-5 shadow-xl">
              <Label11Instructions brannd={brand} dept={deptName} subDept={age} />
            </div>
          </TabsContent>
          <TabsContent value="9">
            <div className="rounded bg-white p-5 shadow-xl">
              <Label12Instructions brannd={brand} dept={deptName} subDept={age} />
            </div>
          </TabsContent>
            </>
          )}
          
          <TabsContent value="4">
            <div className="rounded bg-white p-5 shadow-xl">
              <BrandInstructions brannd={brand} />
            </div>
          </TabsContent>

          <TabsContent value="3">
            <div className="rounded bg-white p-5 shadow-xl">
              <BeltInstructions brannd={brand} />
            </div>
          </TabsContent>

      {brand !== "ZaraHome" && (
        <>
          <TabsContent value="5">
            <div className="rounded bg-white p-5 shadow-xl">
              <CordInstructions />
            </div>
          </TabsContent>
          <TabsContent value="6">
            <div className="rounded bg-white p-5 shadow-xl">
              <AddionalInstructions />
            </div>
          </TabsContent>
          <TabsContent value="7">
            <div className="rounded bg-white p-5 shadow-xl">
              <EmptyInstructions />
            </div>
          </TabsContent>
        </>
      )}

      {brand === "ZaraHome" && (
        <TabsContent value="10">
          <div className="rounded bg-white p-5 shadow-xl">
            {/* Ekstra Kart içeriği buraya eklenecek */}
            <ExtraHomeCardInstructions brannd={brand} />
          </div>
        </TabsContent>
      )}

    </Tabs>
  );
}
